import React, { useState } from 'react';
import { Button } from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';
import { ExportModal } from './ExportModal';
import { useTranslation } from 'react-i18next';

type ExportButtonProps = {
  studyId: string;
  studyName: string;
  study?: { publishedBy?: string };
  variant?: 'contained' | 'outlined' | 'text';
  size?: 'small' | 'medium' | 'large';
  hideText?: boolean;
};

export const ExportButton: React.FC<ExportButtonProps> = ({
  studyId,
  study,
  variant = 'outlined',
  size = 'medium',
  hideText = false,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation();
  return (
    <>
      <Button
        variant={variant}
        size={size}
        startIcon={<DownloadIcon />}
        onClick={() => setModalOpen(true)}
      >
        {!hideText && t('buttons.export')}
      </Button>

      <ExportModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        studyId={studyId}
        study={study}
      />
    </>
  );
};
